// React
import React from "react";
import { Route, Redirect } from 'react-router-dom';

// Stores
import { UserProfileStore } from '../Stores';

const PrivateRoute = ({ render, ...rest }) => (
    <Route {...rest} render={props => (

        UserProfileStore.getUser() !== null ? 
        render(...rest, ...props) :
        (<Redirect to={{pathname: '/login', state: { from: props.location } }} />)
    )} />
);

export default PrivateRoute;


// WEBPACK FOOTER //
// ./src/Utils/PrivateRoute.js